import {Router} from 'express';

/* eslint-disable new-cap */
let router = Router();
/* eslint-enable new-cap */

import home from './home';
import aboutUs from './aboutUs';
import contactUs from './contactUs';
import partners from './partners';
import getquote from './getquote';
import faqs from './faqs';
import solutions from './solutions';
import solutionDetails from './solutionDetails';
import privacy from './privacy';
import termsCondition from './termsCondition';
import ourTeam from './ourTeam';
import career from './career';
import applications from './applications';
import services from './services';
import clubModule from './serviceClubModule';
import financeModule from './serviceFinanceModule';
import membershipModule from './serviceMembershipModule';
import spaModule from './serviceSpaModule';



/* == Homepage section routes == */
router.use('/', home);
router.use('/home', home);

/* == About Us page section routes == */
router.use('/why-us', aboutUs);
router.use('/sobre', aboutUs);

/* == Contact Us page section routes == */
router.use('/contact-us', contactUs);

/* == Partners page section routes == */
router.use('/partners', partners);

/* == Get a Quote page section routes == */
router.use('/get-quote', getquote);

/* == faqs page section routes == */
router.use('/faqs', faqs);

/* == Solution page section routes == */
router.use('/solutions', solutions);
router.use('/solution', solutionDetails);

/* == Clubs page section routes == */
router.use('/privacy-policy', privacy);

/* == Hotel page section routes == */
router.use('/terms-&-condition', termsCondition);

/* == Our Team Pages == */
router.use('/our-team', ourTeam);

/* == Career Pages == */
router.use('/career', career);

/* == Application Pages == */
router.use('/joga-applications', applications);

/* == Application Pages == */
router.use('/service', services);
router.use('/service/club-module', clubModule);
router.use('/service/finance-module', financeModule);
router.use('/service/membership-module', membershipModule);
router.use('/service/spa-module', spaModule);

module.exports = router;
